import React, { useMemo } from "react";
import { Question } from "../../types/Question";

export const CardFeedBeek = ({ feedbeek }: Props) => {
    const colors = useMemo(() => {
        if (feedbeek.multiple) return "gray-700";
        if (!feedbeek.answer) return "";
        if (feedbeek.answer[0].feedbeek === undefined) return ""
        switch (feedbeek.answer[0].feedbeek) {
            case 0:
                return "red-500";
            case 1:
                return "primary-dark";
            case 2:
                return "green-500";
        }
    }, [feedbeek]);

    return (
        <div className="border border-gray-200 rounded-md">
            <div
                className={`border-l-4 rounded-md border-${colors} bg-white p-2 py-4 text-lg`}
            >
                <div className="flex justify-between">
                    <div className="font-semibold">{feedbeek.question}</div>
                    {feedbeek.multiple ? (
                        <div className="border-2 border-primary-dark rounded-md p-1 text-sm">
                            Múltipla escolha
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <div className={`text-${colors}`}>
                    {feedbeek.answer?.map((item) => (
                        <div key={item.id}>R: {item.alternative}</div>
                    ))}
                </div>
            </div>
        </div>
    );
};

interface Props {
    feedbeek: Question;
}
